import axios from "axios";
import { baseURL } from "../utilits/config";

// Add Complain
export function handleAddComplain(complainData, callback) {
  const config = {
    method: "post",
    url: baseURL + "/add-complain",
    headers: {
      "Content-Type": "application/json",
    },
    data: complainData,
  };

  axios(config)
    .then((result) => {
      callback(result.data);
    })
    .catch((error) => {
      // Normalize error response
      const errResponse = {
        ok: 0,
        message:
          error.response?.data?.message ||
          error.message ||
          "Something went wrong",
      };
      callback(errResponse);
    });
}

// Get All Complains (check your endpoint name!)
export function getComplain(callback) {
  const config = {
    method: "get",
    url: baseURL + "/add-complain", // <-- FIXED: changed from /add-complain
  };

  axios(config)
    .then((result) => {
      callback(result.data);
    })
    .catch((error) => {
      const errResponse = {
        ok: 0,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to fetch complains",
      };
      callback(errResponse);
    });
}

// Get Unresolved Complains
export function getUnresolvedComplain(callback) {
  const config = {
    method: "get",
    url: baseURL + "/get-unresolved-complain",
  };

  axios(config)
    .then((result) => {
      callback(result.data);
    })
    .catch((error) => {
      const errResponse = {
        ok: 0,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to fetch unresolved complains",
      };
      callback(errResponse);
    });
}
